import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, SpecraTag, SpecraUserSummary } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { ChevronsUpDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { toast } from './toast';
/**
 * Signed-in user footer for the Specra rails (app + program). Shows the mockup's
 * avatar + email + role chip, and — crucially — opens the account menu
 * (Settings, Help, Sign out) the redesign otherwise dropped. Theme lives in the
 * top bar, so it is not duplicated here.
 */ export function SidebarUserMenu({ user, collapsed = false }) {
    const navigate = useNavigate();
    const { logout, isLoading } = useAuth();
    const roleLabel = user.role ? user.role.replace(/_/g, ' ') : undefined;
    const handleSignOut = async ()=>{
        if (isLoading) {
            toast({
                type: 'error',
                description: 'Please wait, processing...'
            });
            return;
        }
        try {
            await logout();
        } catch (_error) {
            toast({
                type: 'error',
                description: 'Failed to sign out. Please try again.'
            });
        }
    };
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsx("button", {
                    className: "w-full rounded-md px-1 py-1 text-left transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                    "data-testid": Testids.appNav.userMenu,
                    type: "button",
                    children: /*#__PURE__*/ _jsx(SpecraUserSummary, {
                        actions: collapsed ? undefined : /*#__PURE__*/ _jsx(ChevronsUpDown, {
                            "aria-hidden": "true",
                            className: "size-4 shrink-0 text-muted-foreground"
                        }),
                        collapsed: collapsed,
                        name: user.email ?? '',
                        role: roleLabel ? /*#__PURE__*/ _jsx(SpecraTag, {
                            children: roleLabel
                        }) : undefined
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                align: "start",
                className: "w-[--radix-popper-anchor-width] min-w-56",
                side: "top",
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        className: "cursor-pointer",
                        onSelect: ()=>navigate('/settings'),
                        children: "Settings"
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        className: "cursor-pointer",
                        onSelect: ()=>navigate('/help'),
                        children: "Help"
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        children: /*#__PURE__*/ _jsx("button", {
                            className: "w-full cursor-pointer text-left",
                            onClick: handleSignOut,
                            type: "button",
                            children: "Sign out"
                        })
                    })
                ]
            })
        ]
    });
}
